"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RubricsCategoryPanel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Accordion_component_1 = require("@greatmindsorg/gmui-lib/dist/components/Accordion/Accordion.component");
var RubricsCategoryPanel_styled_1 = require("./RubricsCategoryPanel.styled");
var RubricsRadioGroup_1 = require("../RubricsRadioGroup/RubricsRadioGroup");
var api_1 = require("../../../../api");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var react_i18next_1 = require("react-i18next");
var RubricsCategoryPanel = function (_a) {
    var category = _a.category, ratings = _a.ratings, curriculumId = _a.curriculumId, itemRubric = _a.itemRubric, _b = _a.rubricOptions, rubricOptions = _b === void 0 ? [] : _b, _c = _a.isReadOnly, isReadOnly = _c === void 0 ? false : _c, _d = _a.enableExpand, enableExpand = _d === void 0 ? true : _d, onCallBackSelection = _a.onCallBackSelection;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var _e = (0, react_1.useState)([]), criteriaList = _e[0], setCriteriaList = _e[1];
    var _f = (0, react_1.useState)(true), isExpanded = _f[0], setIsExpanded = _f[1];
    var onChangeExpanded = function () {
        if (enableExpand)
            setIsExpanded(!isExpanded);
    };
    var createProficiencyOpt = function (descriptions, scores, proficiencyName, proficiencyId, proficiencySelected) { return ({
        score: (scores === null || scores === void 0 ? void 0 : scores[proficiencyName]) || 0,
        value: proficiencyName,
        description: (descriptions === null || descriptions === void 0 ? void 0 : descriptions[proficiencyName]) || null,
        ratingId: proficiencyId,
        isSelected: proficiencySelected === proficiencyId,
    }); };
    var initialize = (0, react_1.useCallback)(function () {
        var proficiencies = ratings.slice(0, -1);
        var criteria = category.criteria.map(function (_a) {
            var _b;
            var id = _a.id, description = _a.description, score = _a.score;
            var rating = !(0, isEmpty_1.default)(rubricOptions)
                ? (_b = rubricOptions.find(function (opt) { return opt.criterionId === id; })) === null || _b === void 0 ? void 0 : _b.ratingId
                : '';
            return proficiencies.map(function (_a) {
                var id = _a.id, proficiency = _a.proficiency;
                return createProficiencyOpt(description, score, proficiency, id, rating);
            });
        });
        setCriteriaList(criteria);
    }, [category.criteria, ratings, rubricOptions]);
    var updateSelection = function (rubricSelections, criteriaId, newSelection, index) {
        setCriteriaList(function (prev) {
            return prev.map(function (criteria, i) {
                return i === index
                    ? criteria.map(function (option) { return (__assign(__assign({}, option), { isSelected: option.ratingId === newSelection })); })
                    : criteria;
            });
        });
        onCallBackSelection && onCallBackSelection(rubricSelections, criteriaId);
    };
    (0, api_1.useMount)(function () {
        initialize();
    });
    var accordionContent = function () {
        return criteriaList.map(function (criteria, index) {
            var criteriaId = category.criteria[index].id;
            return ((0, jsx_runtime_1.jsxs)("div", { children: [index !== 0 && (0, jsx_runtime_1.jsx)("hr", { className: "border-solid border-b border-b-neutral30" }), (0, jsx_runtime_1.jsx)(RubricsRadioGroup_1.RubricsRadioGroup, { optionsList: criteria, criteriaIndex: index, categoryId: category.id, criteriaId: criteriaId, defaultValue: api_1.DefaultProficiencyByCurriculum[curriculumId], itemRubric: itemRubric, isReadOnly: isReadOnly, onCallBackSelection: updateSelection, curriculumId: curriculumId })] }, "".concat(category.id, "-").concat(criteriaId)));
        });
    };
    var renderAccordion = function () { return ((0, jsx_runtime_1.jsx)(Accordion_component_1.Accordion, { customHideLabel: category.name, customShowLabel: category.name, isOpen: isExpanded, isDisabled: isReadOnly && !enableExpand, onClick: onChangeExpanded, children: (0, jsx_runtime_1.jsx)(RubricsCategoryPanel_styled_1.StyledAccordionContainer, { isReadOnly: isReadOnly, children: accordionContent() }) })); };
    return ((0, jsx_runtime_1.jsx)(RubricsCategoryPanel_styled_1.StyledCategoryPanel, { children: category.name === t('customRubrics.category.name.withoutCategories') ? ((0, jsx_runtime_1.jsx)(RubricsCategoryPanel_styled_1.StyledAccordionContainer, { isReadOnly: isReadOnly, className: "p-4 rounded-m", children: accordionContent() })) : isReadOnly && !enableExpand ? ((0, jsx_runtime_1.jsx)(RubricsCategoryPanel_styled_1.NonInteractiveWrapper, { children: renderAccordion() })) : (renderAccordion()) }));
};
exports.RubricsCategoryPanel = RubricsCategoryPanel;
exports.default = exports.RubricsCategoryPanel;
